module.exports = __webpack_public_path__ + "img/katarina_bedrooms_11.607b651f.jpg";